var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('b-card-group', {
    attrs: {
      "deck": ""
    }
  }, [_c('b-card', {
    attrs: {
      "header": "HUGGIES好奇裸感好動褲派樣包申請活動",
      "header-tag": "header"
    }
  }, [_c('b-card-text', [_vm._v(" 謝謝您申請好奇裸感好動褲派樣包，請務必填寫完成表單資料，並確認收到LINE成功申請訊息 ")])], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mb-2",
    staticStyle: {
      "background": "#5c7580",
      "color": "#fff"
    },
    attrs: {
      "size": "lg",
      "href": "https://line.me/R/ti/p/@huggiestw"
    }
  }, [_vm._v("回好奇 Line 首頁")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }